/**
 * Fixed channel colour convention for the whole product. NVS = brand primary,
 * DPD = contrasting secondary. Charts and legends read these so a rebrand only
 * touches the CSS variables in styles.css.
 */
export const CHANNEL_COLORS = { NVS: 'var(--nvs)', DPD: 'var(--dpd)' } as const;
